import { httpClient } from '@/shared/services/HttpClient';

class FeedbackService {
  url = 'operation/feedback';

  insert(data: any): any {
    return httpClient.post(this.url, data);
  }
}

const feedbackService = new FeedbackService();

export { feedbackService };
